import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "@/components/Layout";
import { useApp } from "@/context/AppContext";
import { ReviewDialog } from "@/components/ReviewDialog";
import API from "@/lib/api";
import { whenLabel, money } from "@/lib/format";
import { Phone, Mail, Check, Award } from "lucide-react";

export default function MyAvailabilities() {
  const navigate = useNavigate();
  const { getCategory, catName } = useApp();
  const [items, setItems] = useState(null);
  const load = () => API.get("/me/availabilities").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  return (
    <Layout>
      <h1 className="font-serif text-2xl font-bold text-[#0F1230] mb-4">Le mie disponibilità</h1>
      {items === null ? <p className="text-[#4A4E68]">Caricamento...</p> : items.length === 0 ? (
        <p className="text-[#4A4E68]">Non ti sei ancora reso disponibile per nessuna richiesta.</p>
      ) : (
        <div className="space-y-3">
          {items.map((a) => {
            const cat = a.request && getCategory(a.request.category);
            return (
              <div key={a.id} data-testid={`my-avail-${a.id}`} className="bg-white rounded-[18px] border border-[#DADFEA] p-4">
                <button onClick={() => a.request && navigate(`/request/${a.request.id}`)} className="text-left w-full">
                  <h3 className="font-semibold text-[#0F1230]">{a.request?.title}</h3>
                  <p className="text-sm text-[#4A4E68]">{cat ? catName(cat) : ""} · {a.request?.city}</p>
                </button>
                <p className="text-sm text-[#2A2E48] mt-2">{a.message}</p>
                <div className="text-xs text-[#4A4E68] mt-1">Quando: {whenLabel(a.when)}{a.price ? ` · ${money(a.price)}` : ""}</div>
                {a.contact_shared && a.requester_contact ? (
                  <div className="mt-3 bg-[#E8F5E9] rounded-xl p-3 text-sm">
                    <p className="text-[#2E7D32] font-medium inline-flex items-center gap-1 mb-1"><Check size={14} /> Contatti condivisi</p>
                    <p className="inline-flex items-center gap-1 text-[#2A2E48]"><Phone size={13} /> {a.requester_contact.phone}</p><br />
                    <p className="inline-flex items-center gap-1 text-[#2A2E48]"><Mail size={13} /> {a.requester_contact.email}</p>
                  </div>
                ) : (
                  <button onClick={() => a.conversation_id && navigate(`/messages/${a.conversation_id}`)} className="text-sm text-[#141A3A] font-medium mt-2">Vai alla chat</button>
                )}
                {a.chosen && (
                  <div className="mt-3 pt-3 border-t border-[#F1F1F7] flex items-center gap-2">
                    <span className="text-sm text-[#2E7D32] inline-flex items-center gap-1"><Award size={14} /> Sei stato scelto!</span>
                    {a.reviewed ? (
                      <span className="text-sm text-[#4A4E68] ml-auto">Recensione lasciata</span>
                    ) : (
                      <div className="ml-auto">
                        <ReviewDialog rid={a.request.id} revieweeId={a.requester_id} revieweeName={a.requester_name || "il richiedente"} onDone={load}
                          triggerLabel="Recensisci il richiedente" triggerTestid={`review-requester-${a.id}`} />
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </Layout>
  );
}
